<template>
    <div id="mobileMenu" v-if="$mq == 'sm'">
        <div v-if="$route.name == 'live'">Live</div>
        <div v-else-if="$route.name == 'archive'">Archive</div>
        <div v-else-if="$route.name == 'about'">About</div>
        <div v-else-if="$route.name == 'logout'">Logout</div>
        <div v-else-if="$route.name == 'login'">Login</div>
        <div v-else-if="$route.name == 'privacy'">Privacy Policy</div>
        <div v-else-if="$route.name == 'shopList'">Shop</div>
        <div v-else-if="$route.name == 'shopDetail'">Shop</div>
        <div v-else-if="$route.name == 'cart'">Cart</div>
        <div v-else>Montez Press Radio</div>
        <img v-if="$mq == 'sm'" @click="store.mobileMenu = true" src="/static/Burger.svg" id="burger" />
    </div>
    <div id="menu" v-else @click="closePopups">
        <router-link :to="{ name: 'home' }">Montez Press Radio</router-link>
        <router-link :to="{ name: 'upcoming' }">Live</router-link>
        <router-link :to="{ name: 'seriesList' }">Series</router-link>
        <router-link :to="{ name: 'archive' }">Archive</router-link>
        <router-link :to="{ name: 'subscribe' }">Support</router-link>
        <router-link :to="{ name: 'proposal' }">Submit</router-link>
        <router-link :to="{ name: 'shopList' }">Shop</router-link>
        <router-link :to="{ name: 'about' }">About</router-link>
        <router-link v-if="this.store.cart.items.length" :to="{ name: 'cart' }">Cart ({{ getCartTotalAmount()
        }})</router-link>

        <div id="spacer"></div>
        <router-link v-if="!store.authenticated" :to="{ name: 'login' }">Login</router-link>
        <router-link v-else :to="{ name: 'logout' }">Logout</router-link>
        <!--
        <span v-else @click="logout" id="logout">Logout</span>
        -->
    </div>
</template>

<script>
import { store } from "../store";
import axios from "axios";

export default {
    name: "Menu",
    data() {
        return {
            store: store,
        };
    },
    methods: {
        getCartTotalAmount() {
            let total = 0;
            this.store.cart.items.forEach((i) => (total += i.amount));
            return total;
        },
        closePopups: function () {
            this.store.showAddPopup = false;
            this.store.showSubWarnPopup = false;
            this.store.showSubExpiredPopup = false;
            this.store.showSwitchPopup = false;
            this.store.showSupportPopup = false;
        },
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        logout() {
            let myself = this;
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios.post("/api/logout").then(() => {
                localStorage.removeItem("authenticated");
                localStorage.removeItem("giftEligible");
                localStorage.removeItem("userID");
                localStorage.removeItem("lastPayed");
                myself.store.authenticated = false;
                myself.store.giftEligible = true;
                myself.store.userID = 0;
                myself.store.lastPayed = null;
                myself.store.valid = false;
            });
        },
    },
    created() {
        axios.get("/api/login-set-cookie");
    },
};
</script>

<style scoped>
#menu,
#mobileMenu {
    padding: 0.7rem 1rem 0.8rem;
    border-bottom: 1px solid black;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    background-color: white;
}

#mobileMenu {
    justify-content: space-between;
}

#menu>a {
    margin-right: 1rem;
    cursor: pointer;
}

#menu>a:last-child {
    margin-right: 0;
}

#spacer {
    flex-grow: 1;
}

#logout {
    cursor: pointer;
}

#burger {
    width: 1.9rem;
    height: 1rem;
    margin-top: 0.3rem;
}
</style>
